import type { ReactNode } from "react";
import { QueryClientProvider } from "@tanstack/react-query";
import { ReactQueryDevtools } from "@tanstack/react-query-devtools";
import { queryClient } from "@/shared/lib/query-client";
import { AuthProvider } from "@/features/auth/AuthProvider";
import { TooltipProvider } from "@/shared/components/ui/tooltip";

export function AppProviders({ children }: { children: ReactNode }) {
  return (
    <QueryClientProvider client={queryClient}>
      {/* delayDuration: show a menu item's explanation after a short hover, like most apps. */}
      <TooltipProvider delayDuration={500} skipDelayDuration={300}>
        <AuthProvider>{children}</AuthProvider>
      </TooltipProvider>
      {import.meta.env.DEV && <ReactQueryDevtools initialIsOpen={false} />}
    </QueryClientProvider>
  );
}
